import type { TOC } from "@ember/component/template-only";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

export interface InputRadioSignature {
  Args: object;
  Element: HTMLInputElement;
}

const InputRadio: TOC<InputRadioSignature> = <template>
  <div class="grid [grid-template-areas:'radio'] *:[grid-area:radio]">
    <input
      class="appearance-none size-4 grid place-items-center bg-white border rounded-full border-gray-200 peer"
      type="radio"
      {{mergeClasses}}
      ...attributes
    />
    <div
      class="scale-0 peer-checked:scale-50 size-4 grid place-items-center border rounded-full border-gray-200 bg-gray-500 transform transition-transform"
    />
  </div>
</template>;

export default InputRadio;
